import { Routes } from '@angular/router';
import { assistantCanActiveGuard } from '@rma/assistant-access/public/util-assistant-guards';

import { CallBeforeUnsubscribeComponent } from './orc-call-before-unsubscribe/call-before-unsubscribe.component';
import { ConfirmPauseComponent } from './orc-confirm-pause/confirm-pause.component';
import { PauseSubscriptionComponent } from './orc-pause-subscription/pause-subscription.component';
import { UnsubscribeCompleteComponent } from './orc-unsubscribe-complete/unsubscribe-complete.component';
import { UnsubscribeConfirmComponent } from './orc-unsubscribe-confirm/unsubscribe-confirm.component';
import { UnsubscribeFeatureEoiComponent } from './orc-unsubscribe-feature-eoi/unsubscribe-feature-eoi.component';
import { UnsubscribeFeatureWarningComponent } from './orc-unsubscribe-feature-warning/unsubscribe-feature-warning.component';
import { UnsubscribeSupportComponent } from './orc-unsubscribe-support/unsubscribe-support.component';
import { checkIsSubscribed } from './unsubscribe.guard';

const unsubscribeRoutes: Routes = [
  {
    path: 'unsubscribe',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    canActivate: [checkIsSubscribed, assistantCanActiveGuard],
    component: UnsubscribeConfirmComponent,
  },
  {
    path: 'unsubscribe-confirm',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    canActivate: [checkIsSubscribed, assistantCanActiveGuard],
    component: UnsubscribeFeatureWarningComponent,
  },
  {
    path: 'unsubscribe-complete',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    canActivate: [checkIsSubscribed, assistantCanActiveGuard],
    component: UnsubscribeCompleteComponent,
  },
  {
    path: 'unsubscribe-eoi',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    canActivate: [checkIsSubscribed, assistantCanActiveGuard],
    component: UnsubscribeFeatureEoiComponent,
  },
  {
    path: 'call-unsubscribe',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    component: CallBeforeUnsubscribeComponent,
    canActivate: [assistantCanActiveGuard],
  },
  {
    path: 'unsubscribe-support',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    component: UnsubscribeSupportComponent,
    canActivate: [assistantCanActiveGuard],
  },
  {
    path: 'pause',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    canActivate: [checkIsSubscribed, assistantCanActiveGuard],
    component: PauseSubscriptionComponent,
  },
  {
    path: 'confirm-pause',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    canActivate: [checkIsSubscribed, assistantCanActiveGuard],
    component: ConfirmPauseComponent,
  },
];

export { unsubscribeRoutes };
